import PrivateRoute from './private-route-container'
export default PrivateRoute
